import React from 'react'
import { Field, reduxForm } from 'redux-form'
import Icon from '../misc/Icons'
import $script from 'scriptjs'
let captcha

///////// Validations//////////////

const requiredFirstName = value => value ? undefined : 'Please enter your first name'
const requiredLastName = value => value ? undefined : 'Please enter your last name'
const requiredEmail = value => value ? undefined : 'Please enter an email address'
const requiredPassword = value => value ? undefined : 'Please enter a password'

const minCharacters = value =>
	value && value.length < 6 ? 'Your password must be at least 6 characters long' : undefined

const validEmailAddress = value =>
	value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z0-9.-]/i.test(value) ?
		"This doesn't look like a valid email address." : undefined

 

class SignUpFormInputField extends React.Component{


	constructor(){
		super()
		this.state={
			showPassword: false, 
		}
	}  


	render(){  

		const {input, styleName, autocomplete, placeholder, type, meta: { touched, error}} = this.props

		return(
			<div 
				className={'signup-form-field' + 
				(styleName ? ` signup-form-field--${styleName} ` : '') + 
				(input.value !== '' ? ' signup-form-field--nonEmpty ' : ' signup-form-field--empty') + 
				(touched && error ? ' signup-form-field--hasError ' : '')        
				}
			>
		 
				{styleName !== 'password' &&
				<input 
					className='signup-form-field-input'
					{...input} 
					placeholder={placeholder}
					type={type}
					autoComplete={autocomplete}
				/>
				}

				{styleName === 'password' &&
				<React.Fragment>
					<input 
						className='signup-form-field-input'        
						{...input} 
						autoComplete={autocomplete}
						placeholder={placeholder}
						type={this.state.showPassword ? 'text' : 'password' }
					/>
					
					<div className='signup-form-field--password-showPassword' onClick={()=>{this.setState({showPassword: !this.state.showPassword})}}>
						{this.state.showPassword && 
							<span>Hide</span>
						}
						{!this.state.showPassword && 
							<span>Show</span>
						}
					</div>
				</React.Fragment>
				}
				
				{touched && error &&
				<div className='signup-form-field-errorIcon'>
					<Icon name='alert' />
				</div>
				} 
			
				{touched && error && 
				<div className="signup-form-field-errorText">
					{error}
				</div>
				}

			</div>
		)
	}
}


class SignupForm extends React.Component{





	constructor(){
		super()
		this.actuallySubmit=this.actuallySubmit.bind(this)
		this.preSubmit=this.preSubmit.bind(this)
		this.reloadCaptcha=this.reloadCaptcha.bind(this)

	}  


	componentDidMount() {
		 $script('https://www.google.com/recaptcha/api.js', () => {
		 	window && window.grecaptcha && window.grecaptcha.ready(() => {
				captcha = window.grecaptcha.render(this.recaptchaDiv, {
					sitekey: process.env.REACT_APP_PLICKERS_RECAPTCHA_SITE_KEY,
					tabIndex:100,
					size: 'invisible',
					callback: this.props.handleSubmit(this.actuallySubmit)
				})
			})
		})
	}




	actuallySubmit(formProps) {
   		const signUpData={...formProps,
   		'recaptchaResponse':window.grecaptcha.getResponse() }
   		this.props.onSubmit(signUpData)
		 window.grecaptcha.reset()
	}


	reloadCaptcha(){
		$script('https://www.google.com/recaptcha/api.js', () => {
		 	window && window.grecaptcha && window.grecaptcha.ready(() => {
				captcha = window.grecaptcha.render(this.recaptchaDiv, {
					sitekey: process.env.REACT_APP_PLICKERS_RECAPTCHA_SITE_KEY,
					tabIndex:100,
					size: 'invisible',
					callback: this.props.handleSubmit(this.actuallySubmit)
				})
				this.preSubmit()
			})
		})

	}



	preSubmit() {
		this.props.onPreSubmit()
	  if(!window.grecaptcha || captcha===undefined) {
	    this.reloadCaptcha()
	    return
	  }
 	 else window.grecaptcha.execute(captcha)
	}


	render(){
		const { handleSubmit,signupError,submitLoading } = this.props

		return(
			<form 
				className={'signup-form ' + 
						(this.props.anyTouched ? ' signup-form--anyTouched ' : '') +
						(this.props.valid ? ' signup-form--valid ' : ' signup-form--invalid')
				} 
				onSubmit={handleSubmit(this.preSubmit)}
			>
				<div className="signup-form-nameContainer">						
					<Field 
						tabIndex={1}
						name="firstName"
						styleName='firstName'
						type="text" 
						component={SignUpFormInputField} 
						validate={requiredFirstName}
						autocomplete='given-name'
						placeholder="First Name"
					/>		        					    
					<Field 
						tabIndex={2}
						name='lastName'
						styleName='lastName'
						type="text" 
						component={SignUpFormInputField} 
						validate={requiredLastName}
						autocomplete='family-name'
						placeholder="Last Name"
					/>	        	
				</div>
					
				<Field 
					tabIndex={3}
					name="email"
					type="email" 
					styleName='email'
					component={SignUpFormInputField} 
					validate={[requiredEmail,validEmailAddress]}
					autocomplete='email'
					placeholder="you@example.com"
				/>
									
				<Field 
					tabIndex={4}
					name="password"
					type="password" 
					styleName='password'
					component={SignUpFormInputField} 
					validate={[requiredPassword, minCharacters]}
					placeholder='Password'
					autocomplete='new-password'
				/>
			

				<button tabIndex={5} className="signup-form-submitBtn" type="submit">
						
					{!submitLoading &&	
						<React.Fragment>
							Continue with Email
						</React.Fragment>
					}

					{submitLoading &&
					<div className='signup-form-submitBtn-loadingSpinnerContainer'>
						<div className='signup-form-submitBtn-loadingSpinner' />
					</div>
					}

				</button>

				{signupError &&
					<div className='signup-form-error'>   
						{signupError}
					</div> 
				}


				<div ref={div => this.recaptchaDiv=div} />


				

			</form>     
		)
	}
}




SignupForm = reduxForm({
	form: 'signupForm',
})(SignupForm)

export default SignupForm

